export const calculateVisiblePages = (currentPage, totalPages) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const siblingCount = 2;
  let start = Math.max(1, currentPage - siblingCount);
  let end = Math.min(totalPages, currentPage + siblingCount);

  if (start === 1) {
    end = Math.min(totalPages, 1 + siblingCount * 2);
  }

  if (end === totalPages) {
    start = Math.max(1, totalPages - siblingCount * 2);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
